module.exports = __webpack_public_path__ + "media/icon/icon-bathtub-green-3b27ad1c.svg";